module.exports = __webpack_public_path__ + "img/4.4917fbc0.svg";